<a
  [href]="url"
  (click)="$event.preventDefault(); emitLanguage()"
  (keydown.enter)="$event.preventDefault(); emitLanguage()"
  tabindex="0"
  class="link"
>
  {{ language.nativeName }}
</a>
<fa-icon [icon]="faChevronRight"></fa-icon>
